module.exports = __webpack_public_path__ + "img/air-conditioner.e76d0bbc.svg";